import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { TeamOutlined } from '@ant-design/icons';
import Farms from "./index";
import ViewFarm from "./view";
import EditFarm from "./edit";
import ViewAccount from "../view";
import { MODULE_ACCT_FARM } from "variables/constants";

const farmRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Farms",
		basePath: "accounts/:accountId/farms",
		mainComponent: <ViewAccount />,
	    layout: "/console",	   
	    icon: <TeamOutlined className="h-6 w-6" />,
	    subTitle:"Farm",
	    viewComponent: <ViewFarm />,
	    createComponent: <EditFarm />,
	    editComponent: <EditFarm />,
		isMainMenu:false,
		level: 2,
		moduleId: MODULE_ACCT_FARM,
	})
]

export default farmRoutes;